import { Drawer } from "antd";
import { observer } from "mobx-react-lite";
import React, { createContext, useContext } from "react";
import renderHTML from "react-render-html";
import QuaiboDailyProductionStore from "../store/quaibodailyproductionstore";
const QuaiboStoreCtx = createContext(QuaiboDailyProductionStore);
export const QuaiboRemarkPane = observer(() => {
  const quaiboDailyProductionStore = useContext(QuaiboStoreCtx);

  return (
    <Drawer
      title={quaiboDailyProductionStore.remarkObj?.title}
      placement="right"
      width={"30%"}
      closable={true}
      destroyOnClose={true}
      onClose={() => {
        quaiboDailyProductionStore.showRemarkPane = false;
      }}
      visible={quaiboDailyProductionStore.showRemarkPane}
    >
      {quaiboDailyProductionStore.remarkObj &&
        renderHTML(quaiboDailyProductionStore?.remarkObj?.remark)}
    </Drawer>
  );
});

